import * as _ from "lodash";

export function once(target: any, propertyKey: string, descriptor: PropertyDescriptor): any {
    const originalMethod = descriptor.value;
    descriptor.value = _.once(originalMethod);
    return descriptor;
}
